import * as React from 'react';

import noop from 'helper/noop';
import { delayed } from 'lib/Job';

import Knob from 'components/atoms/Knob';
import Overlay from 'components/molecules/Overlay';
import ContentImageSlider from 'components/molecules/Slider/ContentImageSlider';

import { TrackingDescriptionIDType } from 'defs/tracking';
import { TrackingDescriptionType } from 'store/trackingDescription';

type TrackingDescriptionItemPropsType = {
	id: TrackingDescriptionIDType;
	description: TrackingDescriptionType;
	open: boolean;
	doCloseDescription: (guideId: TrackingDescriptionIDType) => void;
};

type TrackingDescriptionItemStateType = {
	overlayIsOpen: boolean;
};

class TrackingDescriptionItem extends React.Component<
	TrackingDescriptionItemPropsType,
	TrackingDescriptionItemStateType
> {
	public static displayName = 'TrackingDescriptionItem';

	public state: TrackingDescriptionItemStateType = {
		overlayIsOpen: false,
	};

	public componentDidUpdate(prevProps: TrackingDescriptionItemPropsType) {
		if (prevProps.open === false && this.props.open === true) {
			delayed(() => this.setState({ overlayIsOpen: true }), 1);
		}
	}

	public render() {
		const { overlayIsOpen } = this.state;
		const { id, doCloseDescription = noop, description, open = false } = this.props;

		if (!description || description.images.length === 0) {
			return null;
		}

		return (
			<Overlay
				preventLock
				preventUnlock
				isOpen={open}
				closable
				closeButton={false}
				animation="zoom"
				onClose={() => doCloseDescription(id)}
			>
				<div className="m-card-layer-tracking" data-t-name="CardLayerTracking">
					<div className="m-card-layer-tracking__wrapper">
						<div className="m-card-layer__back">
							<Knob modifier={'filled'} size={'s'} icon="back" attributes={{ 'data-lity-close': true }} />
						</div>
						<div className="m-card-layer-tracking__head">
							<h4 className="m-card-layer-tracking__title">{description.headLine}</h4>
						</div>
						<div className="m-card-layer-tracking__content">
							{overlayIsOpen && <ContentImageSlider id={id} images={description.images} />}
						</div>
					</div>
				</div>
			</Overlay>
		);
	}
}

export default TrackingDescriptionItem;
